// utils/emoji.jsx

const emojiDictionary = {
  // 🏢 Building-related
  buildingIdentification: '\u{1F3E2}', // Office Building 🏢
  buildingHistory: '\u{1F4DC}', // Scroll 📜
  buildingPhysicalCharacteristics: '\u{1F4CF}', // Straight Ruler 📏
  buildingAdministrativeCharacteristics: '\u{1F3DB}', // Classical Building 🏛️
  buildingSurrounding: '\u{1F333}', // Deciduous Tree 🌳
  buildingPeople: '\u{1F465}', // Busts in Silhouette 👥
  building: '\u{1F3E0}', // House 🏠

  // 🔥 Energy & Systems
  heatingSystems: '\u{1F525}', // Fire 🔥
  energy: '\u{26A1}', // High Voltage ⚡
  water: '\u{1F4A7}', // Droplet 💧
  insulation: '\u{1F9F1}', // Brick 🧱

  // 📄 Mandates & documents
  mandate: '\u{1F4C4}', // Page Facing Up 📄
  report: '\u{1F4CA}', // Bar Chart 📊
  link: '\u{1F517}', // Link 🔗
  buildingPermits: '\u{1F4CB}', // Clipboard 📋

  // 👤 People / relations
  customer: '\u{1F464}', // Bust in Silhouette 👤
  partner: '\u{1F91D}', // Handshake 🤝
  prospector: '\u{1F50E}', // Magnifying Glass 🔎

  // 💰 Finance / products
  quotes: '\u{1F4B0}', // Money Bag 💰
  products: '\u{1F4E6}', // Package 📦
  subsidy: '\u{1F4B8}', // Money with Wings 💸
  cost: '\u{1F4B2}', // Heavy Dollar Sign 💲

  // ⚙️ Miscellaneous / system
  settings: '\u{2699}\u{FE0F}', // Gear ⚙️
  info: '\u{2139}\u{FE0F}', // Information ℹ️
  warning: '\u{26A0}\u{FE0F}', // Warning ⚠️
  success: '\u{2705}', // Check ✅
  error: '\u{274C}', // Cross ❌
  camera: '\u{1F4F7}', // Camera 📷

  // 🕒 Timeline & objectives
  timeline: '\u{23F3}', // Hourglass ⏳
  objective: '\u{1F3AF}', // Direct Hit 🎯
  prohibition: '\u{1F6AB}', // No Entry 🚫

  // Arrow
  leftArrow: '\u{2B05}\u{FE0F}', // Left Arrow ⬅️
};

export default emojiDictionary;
